import BigNumber from 'bignumber.js';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { StakingPoolActions } from '../../../actions/new-staking-action';
import { LP_BNB_STAKING_ABI } from '../../../blockchain/abi/typescript/LP_BNB_ABI';
import { LP_STAKING_ABI_BLOCK } from '../../../blockchain/abi/typescript/LP_STAKING_BLOCK';
import { State } from '../../../reducers';
import metamaskService from '../../../services/metamask.service';
import { LPStakingPool } from '../../../services/staking/staking.types';

interface Props {
  pool: LPStakingPool;
}
//@TODO would be good to move this all to redux with redux-thunk
export function useLPStakingActions({ pool }: Props) {
  const { walletAddress } = useSelector(({ account }: State) => ({
    walletAddress: account.address,
  }));
  const { stakingContractAddress, stakingTokenDecimals, rewardTokenDecimals } = pool;
  const metamaskInstance = metamaskService.getInstance();
  const dispatch = useDispatch();
  const { setTransactionId } = bindActionCreators(StakingPoolActions, dispatch);

  const stakingContract = new metamaskInstance.eth.Contract(
    pool.strategyType === 'BLOCK' ? LP_STAKING_ABI_BLOCK : LP_BNB_STAKING_ABI, // this needs to be more dynamic
    stakingContractAddress,
  );

  async function stake(value: string) {
    try {
      const amount = new BigNumber(value)
        .multipliedBy(new BigNumber(10).pow(new BigNumber(stakingTokenDecimals)))
        .toFixed(0);

      const transaction = await stakingContract.methods.stake(amount).send({ from: walletAddress });
      setTransactionId(transaction.transactionHash);
    } catch (_error: unknown) {
      throw _error;
    }
  }

  async function unstake(amount: string) {
    try {
      const decimalAmount = new BigNumber(amount)
        .multipliedBy(new BigNumber(10).pow(new BigNumber(stakingTokenDecimals)))
        .toFixed(0);

      const transaction = await stakingContract.methods
        .unstake(decimalAmount)
        .send({ from: walletAddress });
      setTransactionId(transaction.transactionHash);
    } catch (error) {
      throw error;
    }
  }

  async function claimRewards(amount: string) {
    try {
      const decimalAmount = new BigNumber(amount)
        .multipliedBy(new BigNumber(10).pow(new BigNumber(rewardTokenDecimals)))
        .toFixed(0);

      const transaction = await stakingContract.methods
        .claim(decimalAmount)
        .send({ from: walletAddress });
      setTransactionId(transaction.transactionHash);
    } catch (error) {
      throw error;
    }
  }

  async function withdrawLP(amount: string) {
    try {
      const decimalAmount = new BigNumber(amount)
        .multipliedBy(new BigNumber(10).pow(new BigNumber(rewardTokenDecimals)))
        .toFixed(0);

      const transaction = await stakingContract.methods
        .withdraw(decimalAmount)
        .send({ from: walletAddress });
      setTransactionId(transaction.transactionHash);
    } catch (error) {
      throw error;
    }
  }

  return { stake, unstake, claimRewards, withdrawLP };
}
